import React from 'react';
import BrandCampaignContainer from '../../../Components/Dashboards/BrandCampaign/BrandCampaignContainer';

export default function BrandCampaignPage() {
    return <BrandCampaignContainer />;
}
